/** Prefixo de id sintético só para UI (sem ObjectId no Mongo). */
export const ORPHAN_LIST_ID_PREFIX = '__orphan__';

export function isPersistedListId(id: string | undefined | null): boolean {
  const raw = (id ?? '').trim();
  return Boolean(raw) && !raw.startsWith(ORPHAN_LIST_ID_PREFIX);
}

/**
 * Garante `_id` único (seleção/React key) e `order` = posição no array quando vier vazio.
 * Não inventa ObjectId real — itens órfãos ficam com id `__orphan__…` e não devem chamar a API.
 */
export function normalizeOrderedListItems<T extends { _id?: string; order?: number | null }>(
  items: T[],
  fingerprint: (item: T, index: number) => string,
): Array<T & { _id: string; order: number }> {
  const used = new Set<string>();

  return items.map((item, index) => {
    let id = (item._id ?? '').trim();
    if (!id || used.has(id)) {
      id = `${ORPHAN_LIST_ID_PREFIX}${index}__${fingerprint(item, index)}`;
    }
    used.add(id);

    const rawOrder = item.order;
    const order =
      rawOrder != null && Number.isFinite(Number(rawOrder)) ? Number(rawOrder) : index + 1;

    return { ...item, _id: id, order };
  });
}
